<template>
    <div class="login-container">
        <div class="user-box">
            <div v-if="isLogin" style="height: 40px;display: flex;">
                <span style="display: flex; align-items: center;margin: 5px; color: rgb(222 206 242);">{{ userInfo.name
                }}</span>
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                        <el-avatar :src="avatar"></el-avatar>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click="handleLogout" command="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <!-- <div >{{ userInfo.name }}</div> -->
            <el-button v-else @click="loginWindowVisible = true">注册/登录</el-button>
        </div>

        <!-- 登录/注册 弹窗 start -->
        <el-dialog :visible.sync="loginWindowVisible" :before-close="close" show-close custom-class="loginOutBox"
            :close-on-click-modal="false" >

            <!-- 图形验证码 start -->
            <el-dialog title="请输入验证码" width="300px" :visible.sync="verifyPopupVisible" append-to-body
                :close-on-click-modal="false" :destroy-on-close="true" center>
                <div class="verify-popup-container">
                    <!-- <div style="font-weight: bold;font-size: 18px;">请输入验证码</div> -->
                    <el-input v-model="verifyCode" placeholder="请输入验证码" clearable class="popup-input">
                    </el-input>
                    <img :src="verifyCodeImg" alt="验证码" class="verify-img">
                    <div class="verify-title">看不清楚？
                        <span @click="refreshVerify">换一个</span>
                    </div>
                    <div class="popup-btns">
                        <el-button @click="verifyPopupVisible = false">取消</el-button>
                        <el-button type="primary" @click="submitVerify">提交</el-button>
                    </div>
                </div>
            </el-dialog>
            <!-- 图形验证码 end -->

            <div class="form-header">{{ formTitle }}</div>
            <div class="form-content">
                <!-- 登录 start -->
                <div v-show="formVisible === 'login'">
                    <el-form ref="loginForm" :model="loginForm" :rules="loginFormRules" label-width="0px">
                        <el-form-item prop="phone">
                            <el-input v-model="loginForm.phone" placeholder="请输入手机号码" clearable prefix-icon="el-icon-phone" autocomplete="username">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input v-model="loginForm.password" placeholder="请输入密码" clearable show-password
                                prefix-icon="el-icon-lock">
                            </el-input>
                        </el-form-item>
                        <el-button type="primary" class="submit-btn" @click="handleLogin">登录</el-button>
                    </el-form>

                    <div class="switch-text">
                        <span @click="formSwitch('resetPwd')">忘记密码</span>
                        <!-- <hr> -->
                        <span style="cursor: default;margin: 0 5px;">|</span>
                        <span @click="formSwitch('register')">注册</span>
                    </div>
                    <!-- <el-button></el-button> -->
                </div>
                <!-- 登录 end -->

                <!-- 注册 start -->
                <div v-show="formVisible === 'register'">
                    <el-form ref="registerForm" :model="registerForm" :rules="registerFormRules" label-width="0px">
                        <el-form-item prop="nickname" label="">
                            <el-input v-model="registerForm.nickname" placeholder="请输入昵称" clearable
                                prefix-icon="el-icon-user"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="">
                            <el-input ref="registerPhone" v-model="registerForm.phone" placeholder="请输入手机号码" clearable
                                prefix-icon="el-icon-phone" autocomplete="username"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="verify">
                            <div class="verify-container">
                                <el-input v-model="registerForm.verify" class="verify-input" placeholder="请输入验证码"
                                    clearable></el-input>
                                <el-button :disabled="verifyLoading" @click="showVerifyPopup">{{ verifyBtn }}</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item prop="password" label="">
                            <el-input v-model="registerForm.password" placeholder="请输入密码" clearable show-password
                                prefix-icon="el-icon-lock"></el-input>
                        </el-form-item>
                        <el-button type="primary" class="submit-btn" @click="handleRegister">注册</el-button>
                    </el-form>
                    <div class="switch-text">
                        已有账号<span @click="formSwitch('login')">立即登录</span>
                    </div>
                </div>
                <!-- 注册 end -->


                <!-- 重置 start -->
                <div v-show="formVisible === 'resetPwd'">
                    <el-form ref="resetPwdForm" :model="resetPwdForm" :rules="resetPwdFormRules" label-width="0px">
                        <el-form-item prop="phone" label="">
                            <el-input ref="resetPwdPhone" v-model="resetPwdForm.phone" placeholder="请输入手机号码" clearable
                                prefix-icon="el-icon-phone" autocomplete="username"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="verify">
                            <div class="verify-container">
                                <el-input v-model="resetPwdForm.verify" class="verify-input" placeholder="请输入验证码"
                                    clearable></el-input>
                                <el-button :disabled="verifyLoading" @click="showVerifyPopup">{{ verifyBtn }}</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item prop="password" label="">
                            <el-input v-model="resetPwdForm.password" placeholder="请输入新密码" clearable show-password
                                prefix-icon="el-icon-lock"></el-input>
                        </el-form-item>
                        <el-button type="primary" class="submit-btn" @click="handleResetPwd">重置密码</el-button>
                    </el-form>
                    <div class="switch-text">
                        <span @click="formSwitch('login')">立即登录</span>
                    </div>
                </div>
                <!-- 重置 end -->
            </div>

        </el-dialog>
        <!-- 登录/注册 弹窗 end -->

    </div>
</template>

<script>
import axios from 'axios'
import { ChatUserAPI } from '../../api/user'

export default {
    name: "Login",
    data() {
        return {
            formTitle: '登录',
            verifyBtn: '获取验证码',
            verifyLoading: false,
            verifyCode: '',
            verifyCodeImg: '',
            verifyPopupVisible: false,
            loginWindowVisible: false,
            loginFormVisible: true,
            registerFormVisible: false,
            formVisible: 'login',
            loginForm: { phone: '', password: '' },
            loginFormRules: {
                phone: [
                    {
                        required: true,
                        message: '请输入手机号码',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                        message: '请输入正确的手机号码',
                        trigger: ['blur']
                    }],
                password: [
                    {
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    },
                    {
                        min: 6, max: 30,
                        message: '密码长度应为6-30位',
                        trigger: ['blur', 'change']
                    }]
            },
            registerForm: {
                nickname: '',
                phone: '',
                verify: '',
                password: ''
            },
            registerFormRules: {
                nickname: [
                    {
                        required: true, message: '请输入昵称',
                        trigger: 'blur'
                    },
                    {
                        min: 2, max: 8,
                        message: '昵称长度应为2-8位',
                        trigger: ['blur', 'change']
                    },
                    {
                        pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
                        message: '昵称只能由中文、英文字母、数字和下划线组成',
                        trigger: ['blur', 'change']
                    }
                ],
                phone: [
                    {
                        required: true, message: '请输入手机号码',
                        trigger: 'blur'
                    }, {
                        pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                        message: '请输入正确的手机号码',
                        trigger: ['blur']
                    }
                ],
                verify: [
                    {
                        required: true, message: '请输入验证码',
                        trigger: 'blur'
                    }, {
                        len: 4, message: '验证码长度应为4位',
                        trigger: ['blur']
                    }
                ],
                password: [
                    {
                        required: true, message: '请输入密码',
                        trigger: 'blur'
                    },
                    {
                        min: 6, max: 30, message: '密码长度应为6-30位',
                        trigger: ['blur']
                    }
                ]
            },
            resetPwdForm: {
                phone: '',
                verify: '',
                password: ''
            },
            resetPwdFormRules: {
                phone: [
                    {
                        required: true, message: '请输入手机号码',
                        trigger: 'blur'
                    }, {
                        pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                        message: '请输入正确的手机号码',
                        trigger: ['blur']
                    }
                ],
                verify: [
                    {
                        required: true, message: '请输入验证码',
                        trigger: 'blur'
                    }, {
                        len: 4, message: '验证码长度应为4位',
                        trigger: ['blur']
                    }
                ],
                password: [
                    {
                        required: true, message: '请输入密码',
                        trigger: 'blur'
                    },
                    {
                        min: 6, max: 30, message: '密码长度应为6-30位',
                        trigger: ['blur']
                    }
                ]
            },
            avatar: require('../../assets/images/avatar.jpg'),
        }
    },
    methods: {
        // 切换登录、注册
        formSwitch(target) {
            if (target === 'login') {
                this.formTitle = '登录'
                this.formVisible = 'login'
                // this.loginFormVisible = true
                // this.registerFormVisible = false
                this.$refs.registerForm.resetFields()
            } else if (target === 'register') {
                this.formTitle = '注册'
                this.formVisible = 'register'
                // this.loginFormVisible = false
                // this.registerFormVisible = true
                this.$refs.loginForm.resetFields()
            } else if (target == 'resetPwd') {
                this.formTitle = '重置密码'
                this.formVisible = 'resetPwd'
                // this.loginFormVisible = false
                // this.registerFormVisible = false
                // this.resetFormVisible = true
                this.$refs.loginForm.resetFields()
            }
        },
        // 显示子对话（图形验证码）
        showVerifyPopup() {
            console.info('1')
            if (this.formVisible === 'register') {
                this.$refs.registerForm.validateField('phone', valid => {
                    if (valid) {
                        this.$message.warning(valid)
                    } else {
                        this.refreshVerify()
                        this.verifyPopupVisible = true
                    }
                });
            } else if (this.formVisible === 'resetPwd') {
                this.$refs.resetPwdForm.validateField('phone', valid => {
                    if (valid) {
                        this.$message.warning(valid)
                    } else {
                        this.refreshVerify()
                        this.verifyPopupVisible = true
                    }
                });
            }

        },
        // 刷新 图形验证码 0 注册，1 登录
        refreshVerify() {
            const type = this.formVisible === 'register' ? 0 : 1
            const phone = this.formVisible === 'register' ? this.registerForm.phone : this.resetPwdForm.phone
            var timestamp = new Date().getTime();
            const url = process.env.BASE_API + '/api/users/image-code?phone=' + phone + '&type=' + type + '&timestamp=' + timestamp;
            // this.verifyCodeImg = require(url);
            axios.get(url, { responseType: 'arraybuffer' }).then(resp => {
                const base64 = btoa(
                    new Uint8Array(resp.data).reduce(
                        (data, byte) => data + String.fromCharCode(byte),
                        ''
                    )
                )
                this.verifyCodeImg = `data:image/jpeg;base64,${base64}`
            })
        },
        // 提交 图形验证码
        submitVerify() {
            if (this.verifyCode === '') {
                this.$message.warning('验证码不能为空')
                return
            }
            const type = this.formVisible === 'register' ? 0 : 1
            const phone = this.formVisible === 'register' ? this.registerForm.phone : this.resetPwdForm.phone
            ChatUserAPI.sendSmsCode(phone, type, this.verifyCode).then(resp => {
                this.verifyLoading = true
                this.countTime()
                this.$message.success('验证码已发送')
                this.verifyPopupVisible = false
            }).catch(error => {
                this.refreshVerify()
            })
        },
        // 倒计时
        countTime() {
            //倒计时60秒
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.isDisabled = true;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                        this.verifyBtn = this.count + '秒后获取'
                    } else {
                        this.isDisabled = false;
                        clearInterval(this.timer);
                        this.timer = null;
                        this.verifyLoading = false
                        this.verifyBtn = '获取验证码'
                    }
                }, 1000);
            }
        },
        // 注册
        handleRegister() {
            this.$refs.registerForm.validate(valid => {
                if (valid) {
                    ChatUserAPI.register(this.registerForm).then(resp => {
                        this.$message.success('注册成功！')
                        this.loginWindowVisible = false;
                        this.$store.commit('saveUserInfo', resp)
                    })
                } else {
                    this.$message.warning('请检查输入')
                }
            })
        },

        // 登录
        handleLogin() {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    ChatUserAPI.login(this.loginForm)
                        .then(resp => {
                            this.$message.success('登录成功！')
                            this.loginWindowVisible = false;
                            this.$store.commit('saveUserInfo', resp)
                        })
                }
                else {
                    this.$message.warning('请检查输入')
                }
            })
        },
        // 重置密码
        handleResetPwd() {1
            this.$refs.resetPwdForm.validate(valid => {
                if (valid) {
                    ChatUserAPI.editPassword(this.resetPwdForm).then(resp => {
                        this.$message.success('重置密码成功！')
                        this.formVisible = 'login';
                        // this.$store.commit('saveUserInfo', resp)
                    })
                } else {
                    this.$message.warning('请检查输入')
                }
            })
        },

        // 登出
        handleLogout() {
            ChatUserAPI.logout().then(resp => {
                this.$store.commit('cleanUserInfo')
                this.$message.success('登出成功')
                if (this.$route.path === '/account') {
                    this.$router.replace("/")
                }
            }).catch(() => {
                this.$store.commit('cleanUserInfo')
                if (this.$route.path === '/account') {
                    this.$router.replace("/")
                }
            })
        },
        // 处理用户菜单
        handleCommand(command) {
            if (command === 'logout') {
                this.handleLogout()
            }
        },
        // 关闭弹窗
        close(done) {
            this.$refs.registerForm.resetFields()
            this.$refs.loginForm.resetFields()
            this.formSwitch('login')
            done()
        }
    },
    created() {
    },
    computed: {
        isLogin() {
            return this.$store.state.isLogin
        },
        userInfo() {
            return this.$store.state.userInfo
        }
    }
} 
</script>

<style scoped >
/* 登录子模块样式 */
login-container /deep/ .el-dialog__header {
    padding: 0;
}

.el-dialog__body {
    padding: 0 20px;
}

.loginOutBox {
    width: 30%;
    min-width: 400px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .2);
    border-radius: 10px;
}

.form-header {
    text-align: center;
    font-size: 24px;
    color: #639;
    font-weight: bold;
    margin-bottom: 10px;
    line-height: 40px;
}

.login-container {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    /* z-index: 9999; */
    /* background-color: rgba(191, 186, 196, 0.9); */
}

.user-box {
    margin: 10px;
    display: flex;
    float: right;
}

/* 弹窗 */
.switch-text {
    text-align: right;
    line-height: 40px;
}

.switch-text span {
    cursor: pointer;
    color: #639;
}

.verify-container {
    display: flex;
    align-items: center;
}

.verify-container .verify-input {
    flex-grow: 1;
    margin-right: 10px;
}

.verify-container .verify-btn {
    font-size: 12px;
    color: #fff;
    background-color: #639;
    border: none;
    border-radius: 2px;
    outline: none;
    cursor: pointer;
}

.verify-popup-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* padding: 0 20px 20px 20px; */
}

.verify-title {
    margin-bottom: 10px;
}

.verify-title span {
    cursor: pointer;
    color: #639;
}

.verify-img {
    margin-top: 10px;
    cursor: pointer;
}

.popup-input {
    margin-top: 10px;
    width: 200px;
    text-align: center;
}

.popup-btns {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.submit-btn {
    margin-top: 10px;
    width: 100%;
}

@media screen and (max-width: 767px) {
    .loginOutBox {
        width: 90%;
    }

    .login-container /deep/ .el-dialog {
        width: 90%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/page/Login.vue